import styled from 'styled-components';
import { devices } from "../data/constants";

export const TabsContainerStyled = styled.div`
    font-family: ${({ theme }) => theme.colors.ff};
    flex: 1;
    margin: 0px auto;
    margin-bottom: 100px;
    padding: 20px;
    width: 85%;
    z-index: 0;
    background: ${({ theme }) => theme.colors.cardBG};
    min-height: 400px;
    @media only screen and ${devices.md} {
        width: 85%;
    }
`;

export const FormSectionStyled = styled.section`
    width: 100%;
    max-width: 420px;
    background: ${({ theme }) => theme.colors.cardBG};
    border-radius: 16px;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 60px;
    padding: 40px 36px;
    color: ${({ theme }) => theme.colors.cardText};
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
    
    @media only screen and ${devices.md} {
        width: 90%;
        padding: 32px 24px;
        margin-top: 40px;
    }
`;


export const InputContainerStyled = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    margin: ${props => ["text", "date", "shorttext"].includes(props.$type)?"0 0 20px 0":["checkbox", "number"].includes(props.$type)?"0px":"0 0 20px 0"};
    justify-content: center;
    width: ${props => props.$size ? `${props.$size}%`:"100%"};
    max-width: ${props =>  props.$type==="select"?"200px":props.$type==="date"?"800px":""};
    align-items: ${props => props.$type === "checkbox" ? "flex-start" : ""};
    @media only screen and ${devices.md} {
        width: ${props => props.$mobileSize ? `${props.$mobileSize}%`:"100%"};
        max-width: 100%;
    }
`;

export const InputStyled = styled.input`
    border-radius: 10px;
    width: 100%;
    border: 1.5px solid ${({ theme }) => theme.colors.borderColor};
    padding: 14px 16px;
    padding-right: 44px;
    vertical-align: top;
    font-size: 15px;
    font-family: ${({ theme }) => theme.colors.ff};
    background: ${({ theme }) => theme.colors.inputBg};
    color: ${({ theme }) => theme.colors.cardText};
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
    -moz-appearance: textfield;
    
    &::placeholder {
        color: ${({ theme }) => theme.colors.subTextColor};
        opacity: 0.7;
    }
    
    &:focus {
        outline: none;
        border-color: #6366f1;
        box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.15);
    }
    
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }  
`;

export const InputIconStyled = styled.div`
    position: absolute;
    right: 14px;
    bottom: 14px;
    color: ${({ theme }) => theme.colors.subTextColor};
    cursor: ${props => props.$clickable ? `pointer` : ``};
    transition: color 0.2s ease;
    
    &:hover {
        color: ${props => props.$clickable ? ({ theme }) => theme.colors.cardText : ''};
    }
`;

export const LabelStyled = styled.label`
    font-size: 13px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.cardText};
    margin-bottom: 6px;
    display: block;
`;

export const FormContainerStyled = styled.div`
    font-family: ${({ theme }) => theme.colors.ff};
    flex: 1;
    margin: 0 auto;
    
    p {
        margin-top: 24px;
        text-align: center;
        font-size: 14px;
        color: ${({ theme }) => theme.colors.subTextColor};
        
        a {
            color: #6366f1;
            font-weight: 500;
            text-decoration: none;
            transition: color 0.2s ease;
            
            &:hover {
                color: #4f46e5;
            }
        }
    }
`;

export const FormNavContainerStyled = styled.div`
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    height: 80px; 
    display: flex;
    align-items: center;
    justify-content: ${props => props.$single?`flex-end`:`space-between`};
    background: ${({ theme }) => theme.colors.bg};
`;

export const ButtonContainerStyled = styled.div`
    display: flex;
    margin-top: 8px;
    
    button {
        width: 100%;
        padding: 14px 24px;
        font-size: 15px;
        font-weight: 600;
        border-radius: 10px;
        transition: all 0.2s ease;
    }
`;

export const GoogleButtonContainerStyled = styled.div`
    width: 100%;    
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 8px 0px;
`;

export const OrContainerStyled = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 24px 0;
    
    p {
        margin: 0 !important;
        padding: 0 16px;
        font-size: 13px;
        color: ${({ theme }) => theme.colors.subTextColor};
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
`;

export const HrStyled = styled.hr`
    flex: 1;
    height: 1px;
    background: ${({ theme }) => theme.colors.borderColor};
    border: none;
    margin: 0;
`;

export const PlansButton = styled.div`
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.colors.cardText};
    margin-left: 12px;
    text-align: center;
`;

export const PlanViewContainerStyled = styled.div`
    margin: 16px 8px 4px 0px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`;

export const GoogleButtonStyled = styled.div`
    transition: all 0.2s ease;
    cursor: pointer; 
    padding: 14px 24px 14px 48px;
    border: 1.5px solid ${({ theme }) => theme.colors.borderColor};
    border-radius: 10px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    color: ${({ theme }) => theme.colors.cardText};
    font-size: 15px;
    font-weight: 500;
    font-family: inherit;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTcuNiA5LjJsLS4xLTEuOEg5djMuNGg0LjhDMTMuNiAxMiAxMyAxMyAxMiAxMy42djIuMmgzYTguOCA4LjggMCAwIDAgMi42LTYuNnoiIGZpbGw9IiM0Mjg1RjQiIGZpbGwtcnVsZT0ibm9uemVybyIvPjxwYXRoIGQ9Ik05IDE4YzIuNCAwIDQuNS0uOCA2LTIuMmwtMy0yLjJhNS40IDUuNCAwIDAgMS04LTIuOUgxVjEzYTkgOSAwIDAgMCA4IDV6IiBmaWxsPSIjMzRBODUzIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNNCAxMC43YTUuNCA1LjQgMCAwIDEgMC0zLjRWNUgxYTkgOSAwIDAgMCAwIDhsMy0yLjN6IiBmaWxsPSIjRkJCQzA1IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48cGF0aCBkPSJNOSAzLjZjMS4zIDAgMi41LjQgMy40IDEuM0wxNSAyLjNBOSA5IDAgMCAwIDEgNWwzIDIuNGE1LjQgNS40IDAgMCAxIDUtMy43eiIgZmlsbD0iI0VBNDMzNSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PHBhdGggZD0iTTAgMGgxOHYxOEgweiIvPjwvZz48L3N2Zz4=);
    background-color: ${({ theme }) => theme.colors.bg};
    background-repeat: no-repeat;
    background-position: 16px center;

    &:hover {
        border-color: ${({ theme }) => theme.colors.cardText};
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    &:active {
        transform: scale(0.99);
    }
`;

export const RecaptchaContainerStyled = styled.div`
    margin: 16px 8px 8px 0px;
    
    @media only screen and ${devices.md} {
            max-height: 48px;
    }
    div iframe {
        
        @media only screen and ${devices.md} {
            transform:scale(0.8);
            -webkit-transform:scale(0.8);
            transform-origin:0 0;
            -webkit-transform-origin:0 0;
        }
        @media only screen and ${devices.sm} {

            transform:scale(0.7);
            -webkit-transform:scale(0.7);
            transform-origin:0 0;
            -webkit-transform-origin:0 0;
        }
      }
`;

export const ErrorMessageStyled = styled.p`
    color: #ef4444;
    font-size: 14px;
    margin: 12px 0;
    padding: 12px 16px;
    background: rgba(239, 68, 68, 0.1);
    border-radius: 8px;
    border-left: 3px solid #ef4444;
`;

export const PaginationContainerStyled = styled.div`
    display: flex;
    justify-content: center;
    margin: 30px 0px;
`;